import { render, staticRenderFns } from "./chart-rose.vue?vue&type=template&id=b0d125a2"
import script from "./chart-rose.vue?vue&type=script&lang=js"
export * from "./chart-rose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports